import { Navigate, useParams } from 'react-router-dom'

type Props = {
  to: string
}

export const LegacyRedirect = ({ to }: Props) => {
  const params = useParams()
  let redirectPath = to

  Object.entries(params).forEach(([key, value]) => {
    redirectPath = redirectPath.replace(`:${key}`, value || '')
  })

  return <Navigate to={redirectPath} replace />
}
